import React, { useState, useEffect, useRef } from 'react';
import styles from './audio.module.scss';
import { KoButton} from 'packages';
import KoIcon from '@kwapio/icons';
import { Progress } from 'antd';
import WavesurferPlayer from '@wavesurfer/react';

const formatTime = (time) => {
  const minutes = Math.floor(time / 60)
    .toString()
    .padStart(2, '0');
  const seconds = Math.floor(time % 60)
    .toString()
    .padStart(2, '0');
  return `${minutes}:${seconds}`;
};

const AudioViewer = ({ filePath }) => {
  const wavesurferRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);

  const togglePlayPause = () => {
    const ws = wavesurferRef.current;
    if (ws) ws.playPause();
  };

  const onReady = (ws) => {
    wavesurferRef.current = ws;
    setDuration(ws.getDuration());
    setIsPlaying(false);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      const ws = wavesurferRef.current;
      if (ws && isPlaying) {
        setCurrentTime(ws.getCurrentTime());
      }
    }, 200);

    return () => clearInterval(interval);
  }, [isPlaying]);

  const percentage = duration ? (currentTime / duration) * 100 : 0;

  return (
    <div className={styles.wrapper}>
      <div className={styles.progressContainer}>
        <Progress
          type="circle"
          percent={percentage}
          size={60}
          strokeColor={{ '0%': '#108ee9', '100%': '#87d068' }}
          format={() => ''}
        />
        <div className={styles.centerButton}>
          <KoButton
            iconBtn
            type="text"
            onClick={togglePlayPause}
            icon={
              <KoIcon
                width={24}
                height={24}
                name={isPlaying ? 'PauseOutlined' : 'PlayOutlined'}
              />
            }
          />
        </div>
      </div>
      <div className={styles.audioStatusIcon}>
        <WavesurferPlayer
          height={80}
          waveColor="violet"
          progressColor="purple"
          barWidth={2}
          url={filePath}
          onReady={onReady}
          onPlay={() => setIsPlaying(true)}
          onPause={() => setIsPlaying(false)}
        />
      </div>
      <div className={styles.time}>
        {formatTime(currentTime)} / {formatTime(duration)}
      </div>
    </div>
  );
};

export default AudioViewer;
